import { jsx as n, jsxs as l, Fragment as k } from "react/jsx-runtime";
import A, { useMemo as m } from "react";
import e from "./style.module.less.js";
import T from "./social-fb.svg.js";
import _ from "./social-instagram.svg.js";
import q from "./social-tik-tok.svg.js";
import E from "./social-youtube.svg.js";
import F from "./social-ln.svg.js";
import R from "./logo-white.webp.js";
import { CountryLanguageSelector as D } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as M, canLanguageUseAtticus as x, areasOfLawData as S, withDirectoryCountries as v, directoryBaseData as b } from "../../../constants.js";
import { convertToKebabCase as C } from "../../../utils/case-conversion.js";
import { getRoute as N, RouteType as w } from "../../../utils/get-route.js";
import W from "../menu/message-animated.svg.js";
import L from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as Y } from "../../../context/config-context.js";
const B = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: T
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: _
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: q
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: F
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: E
  }
], H = () => /* @__PURE__ */ n("div", { className: e.socialContainer, children: B.map((r) => /* @__PURE__ */ n(
  "a",
  {
    href: r.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": r.name,
    className: e.socialIconContainer,
    children: /* @__PURE__ */ n(r.Icon, { width: 32, height: 32, className: e.socialIcon })
  },
  r.name
)) }), ce = (r) => {
  const {
    className: a = "",
    onLanguageChange: u,
    isAuthenticated: o,
    openAuthModal: d,
    language: s = M,
    getTranslation: i,
    isLawyerSupported: y,
    onRequestLawyer: f
  } = r, g = m(() => s === "en-au", [s]), p = m(() => x(s) ? s : void 0, [s]), I = m(
    () => i("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, s ? `/${s}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      s ? `/${s}/privacy` : "/privacy"
    ),
    [i, s]
  ), t = m(() => s ? S[s] : null, [s]), h = /* @__PURE__ */ n(
    D,
    {
      onLanguageChange: u,
      language: s ?? ""
    }
  ), c = () => /* @__PURE__ */ n(
    "a",
    {
      href: "/account",
      className: `${e.menuItem}`,
      onClick: ($) => {
        o || ($.preventDefault(), d == null || d());
      },
      children: i("pages.account")
    }
  );
  return /* @__PURE__ */ n("footer", { className: `${e.footer} ${a}`, children: /* @__PURE__ */ l("div", { className: e.widthWrapper, children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: `${e.logoContainer} ${t != null && t.length ? e.large : ""}`,
        children: [
          /* @__PURE__ */ n("a", { href: s ? `/${s}` : "/", className: e.logo, children: /* @__PURE__ */ n(
            "img",
            {
              src: R,
              width: 202,
              height: 28,
              alt: "LawConnect Logo",
              loading: "lazy",
              className: e.logoImage
            }
          ) }),
          /* @__PURE__ */ n("div", { className: e.headerLanguageSelector, children: h })
        ]
      }
    ),
    t != null && t.length ? /* @__PURE__ */ n("div", { className: `${e.gridContainer} ${e.large}`, children: /* @__PURE__ */ n(
      K,
      {
        language: s,
        accountComponent: /* @__PURE__ */ n(c, {}),
        isLawyerSupported: y,
        onRequestLawyer: p ? f : void 0,
        isLegalMarketplaceEnabled: g
      }
    ) }) : /* @__PURE__ */ n("div", { className: e.gridContainer, children: /* @__PURE__ */ n(
      Q,
      {
        language: s,
        accountComponent: /* @__PURE__ */ n(c, {}),
        getTranslation: i
      }
    ) }),
    /* @__PURE__ */ l("div", { className: e.bottomBarContainer, children: [
      /* @__PURE__ */ l("div", { className: e.bottomSocialContainer, children: [
        /* @__PURE__ */ n(H, {}),
        /* @__PURE__ */ n("div", { className: e.languageSelectorContainer, children: h })
      ] }),
      /* @__PURE__ */ l("div", { className: e.copyright, children: [
        /* @__PURE__ */ n("div", { children: i("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ l("div", { className: e.copyrightBottom, children: [
          /* @__PURE__ */ l("div", { children: [
            i("auth.copyright-description"),
            " "
          ] }),
          t != null && t.length ? /* @__PURE__ */ n("div", { dangerouslySetInnerHTML: { __html: I } }) : null
        ] })
      ] })
    ] })
  ] }) });
}, K = (r) => {
  const { language: a, accountComponent: u, isLawyerSupported: o, isLegalMarketplaceEnabled: d, onRequestLawyer: s } = r, { diyWill: i } = Y(), y = m(() => {
    const t = S[a];
    return v.includes(a) ? [
      ...t,
      {
        title: b.footerTitle ?? "",
        description: b.description,
        image: b.image,
        link: "topics"
      }
    ] : t;
  }, [a]), f = m(() => v.includes(a), [a]), g = o ? 5 : 4, p = m(() => {
    const t = g * 2, h = y.slice(0, t);
    return [h.slice(0, g), h.slice(g)];
  }, [y, g]), I = m(() => [
    {
      header: "Browse",
      items: [
        {
          key: "request",
          label: "Request a lawyer",
          href: s ? void 0 : N(w.LAWYER_REQUEST_CHAT),
          icon: /* @__PURE__ */ n(W, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.requestLawyer}`,
          show: !!o,
          onClick: s
        },
        {
          key: "ask",
          label: "Ask a question",
          href: N(w.NEW_CHAT),
          icon: /* @__PURE__ */ n(L, { className: e.menuIcon }),
          className: `${e.menuItem} ${e.askQuestion}`
        },
        {
          key: "library",
          label: "Legal topics",
          href: `/${a}/topics`,
          className: e.menuItem
        },
        {
          key: "about",
          label: "About",
          href: o ? a ? `/${a}/about/company` : "/about/company" : a ? `/${a}/about` : "/about",
          className: e.menuItem
        },
        {
          key: "for-lawyers",
          label: "For lawyers",
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: e.menuItem
        },
        {
          key: "account",
          node: u,
          show: !o
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: N(w.WILL_INFO),
          className: e.menuItem,
          show: a === "en-us" && i === !0
        },
        {
          key: "find-a-lawyer",
          label: "Find a lawyer",
          href: a ? `/${a}/find` : "/find",
          className: e.menuItem,
          show: !!o && d
        },
        {
          key: "insights",
          label: "Insights",
          href: a ? `/${a}/insights` : "/insights",
          className: e.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: a ? `/${a}/faqs` : "/faqs",
          className: e.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: a ? `/${a}/directory` : "/directory",
          className: e.menuItem,
          show: f && !!o && !d
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: e.menuItem,
          show: !o && !(a === "en-us" && i === !0)
        },
        {
          key: "company",
          label: "Company",
          href: a ? `/${a}/about/company` : "/about/company",
          className: e.menuItem,
          show: !o
        },
        {
          key: "contact",
          label: "Contact us",
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: e.menuItem
        },
        {
          key: "account",
          node: u,
          show: !!o
        }
      ]
    },
    {
      header: "Topics",
      items: p[0].map((t) => ({
        key: `area-1-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: t.link === "topics" ? `/${a}/topics` : `/${a}/topics/${t.link ?? C(t.title)}`,
        className: e.menuItem
      }))
    },
    {
      header: "",
      items: p[1].map((t) => ({
        key: `area-2-${t.title}`,
        label: t.footerTitle ?? t.title,
        href: t.link === "topics" ? `/${a}/topics` : `/${a}/topics/${t.link ?? C(t.title)}`,
        className: e.menuItem
      }))
    }
  ], [
    a,
    o,
    f,
    p,
    u,
    i
  ]);
  return /* @__PURE__ */ n(k, { children: I.map((t, h) => /* @__PURE__ */ l("div", { className: e.column, children: [
    /* @__PURE__ */ n("div", { className: e.headerLabel, children: t.header ?? "" }),
    t.items.filter((c) => c.show !== !1).map(
      (c, $) => c.node ? /* @__PURE__ */ n(A.Fragment, { children: c.node }, `${c.key}-${$}`) : /* @__PURE__ */ n(
        "a",
        {
          href: c.href,
          className: c.className ?? e.menuItem,
          onClick: c.onClick,
          children: c.icon ? /* @__PURE__ */ l(k, { children: [
            /* @__PURE__ */ n("span", { className: e.menuItemText, children: c.label }),
            c.icon
          ] }) : /* @__PURE__ */ n(k, { children: c.label })
        },
        c.key
      )
    )
  ] }, h)) });
}, Q = (r) => {
  const { language: a, accountComponent: u, getTranslation: o } = r;
  return /* @__PURE__ */ l(k, { children: [
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ l(
        "a",
        {
          href: N(w.NEW_CHAT),
          className: `${e.menuItem} ${e.askQuestion}`,
          children: [
            o("pages.ask-a-question"),
            /* @__PURE__ */ n(L, { className: e.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about/company` : "/about/company",
          className: `${e.menuItem}`,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: `${e.menuItem}`,
          children: o("register.for-lawyers")
        }
      )
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      a.includes("en") ? /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/insights` : "/insights",
          className: `${e.menuItem}`,
          children: o("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/faqs` : "/faqs",
          className: `${e.menuItem}`,
          children: o("pages.faqs")
        }
      ),
      a.includes("en") ? null : /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/about/ai-technology` : "/about/ai-technology",
          className: `${e.menuItem}`,
          children: o("pages.ai-technology")
        }
      ),
      u
    ] }),
    /* @__PURE__ */ l("div", { className: e.column, children: [
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/contact-us` : "/contact-us",
          className: `${e.menuItem}`,
          children: o("pages.contact-us")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/terms` : "/terms",
          className: `${e.menuItem}`,
          children: o("pages.terms")
        }
      ),
      /* @__PURE__ */ n(
        "a",
        {
          href: a ? `/${a}/privacy` : "/privacy",
          className: `${e.menuItem}`,
          children: o("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  ce as FooterComponent,
  B as SOCIAL_MEDIA_LINKS
};
